import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  SET_MOKA_CONFIG_LIST,
  SET_MOKA_CONFIG_LOGS_LIST,
} from 'state/actionTypes';

const mokaConfigsInitialState = {
  prices: [],
  discounts: [],
};

const mokaConfigLogsInitialState = {
  data: {
    internal_tools_activities: [],
  },
  paging: {
    page: 1,
    size: 10,
    total: 2,
  },
};

const mokaConfigs = createReducer(mokaConfigsInitialState, {
  [SET_MOKA_CONFIG_LIST]: (state, { payload }) => ({ ...state, ...payload }),
});

const mokaConfigLogs = createReducer(mokaConfigLogsInitialState, {
  [SET_MOKA_CONFIG_LOGS_LIST]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
});

export default combineReducers({
  mokaConfigs,
  mokaConfigLogs,
});
